import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({

    footer: {
      position: 'fixed',
      backgroundColor: '#0E1444',
      bottom: 0,
      borderRadius: '40px 40px 0px 0px',
      textAlign: 'center',
    },
    draftButton: {
      margin: 5,
      color: 'white',
      fontSize: 14,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      lineHeight: 14,
      wordWrap: 'break-word',
      border: '1px solid #FFF',
      textTransform: 'none',
    },
    publishButton: {
      margin: 5,
      color: '#000A8C',
      fontSize: 14,
      fontFamily: 'Open Sans',
      fontWeight: 600,
      lineHeight: 14,
      wordWrap: 'break-word',
      borderRadius: 5,
      background: '#FFF',
      textTransform: 'none',
      '&:hover': {
        border: '1px solid white',
        color: 'white',
      },
    },
  })
);
